import GaugeDial from '../../plots/GaugeDial';
import BarChart from '../../plots/BarChart';
import { useAppStateContext } from '../../../hooks/useAppState';
import MPIComparisonPanel from './MPIComparisonPanel';

// Overall Performance Panel (AKA Multi Parameter Index)
// Consists of a Bar chart (of the AHP Weights) and the overall Multi Parameter Index score on a gauge dial
// The Comparison panel is also here, which will only show anything if comparison mode is turned on
export default function OverallPerformancePanel({
  barColor = '#1e40af',
  title = 'Overall Performance Index',
  barTitle = 'Analyte Weights',
}) {
  const { state, getSelectedBmpLabel } = useAppStateContext();
  const mpiData = state.mpiData || [];
  // Only show if at least one analyte has a valid weight
  const hasValidWeight = mpiData.length > 0 && mpiData.some(d => !isNaN(d.weight));
  const overallIndex = mpiData.reduce(
    (sum, d) => (!isNaN(d.weight) && !isNaN(d.score)) ? sum + d.weight * d.score : sum,
    0
  );
  
  if (!hasValidWeight) return null;
  return (
    <div className="my-8 w-full">
      {/* Main title */}
      <h3 className="text-lg font-semibold mb-6 text-center">{title}</h3>
      
      <div className="flex flex-col md:flex-row gap-8 min-h-[500px]">
        {/* Left: BarChart */}
        <div className="w-full md:w-1/2 flex flex-col">
          <h3 className="text-lg font-semibold mb-4">{barTitle}</h3>
          <div className="flex-1 flex items-center">
            <BarChart
              data={mpiData.map(d => ({ label: d.analytename, value: isNaN(d.weight) ? 0 : d.weight }))}
              xLabel="Analyte"
              yLabel="Weight"
              barColor={barColor}
              showTooltip={true}
            />
          </div>
        </div>
        
        {/* Right: Performance Gauges */}
        <div className="w-full md:w-1/2 flex flex-col gap-8 justify-center">
          {/* Selected BMP Gauge */}
          <div className="flex flex-col items-center">
            <h4 className="text-md font-semibold mb-2 text-center">{getSelectedBmpLabel()}</h4>
            <GaugeDial value={overallIndex} />
          </div>
          
          {/* Comparison Gauge */}
          <MPIComparisonPanel />
        </div>
      </div>
    </div>
  );
} 